export default "__VITE_ASSET__DcSKvr3U__"